"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetToolbar = void 0;
var react_1 = __importDefault(require("react"));
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var useSelectionState_1 = require("./useSelectionState");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WidgetManager_1 = require("../WidgetManager");
var inversify_react_1 = require("inversify-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var SyntheticSelection_1 = require("Project/SyntheticSelection");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var widgetStyle_1 = require("Utils/widgetStyle");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var StringManipulater_1 = require("@CommonFrontend/Utils/StringManipulater");
var ClientColorProvider_1 = require("DreamCoat/ClientColorProvider");
var Styleable_1 = require("./Styleable");
var styles = __importStar(require("./WidgetToolbar.css"));
exports.WidgetToolbar = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var element = _a.element, anchorElement = _a.anchorElement;
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var clearSelection = (0, SyntheticSelection_1.useSelectionStore)().clearSelection;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var dragStore = (0, inversify_react_1.useInjection)("dragStore");
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var colorProvider = (0, ClientColorProvider_1.useColorProvider)();
    var config = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type);
    var WidgetButtons = config === null || config === void 0 ? void 0 : config.toolbarButtons;
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: element.type, traitName: "styleable" });
    var isAlignable = (0, EditorWidgetRegistry_1.isAlignableWidget)(element);
    var disableLeftAlignment = isAlignable && (0, EditorWidgetRegistry_1.isResizeableWidget)(element) && (element.data.width === "full" || element.data.width === "wide");
    var blockStyle = styleableConfig ? blockStore.blockStyleStore.model[styleableConfig.styleKey] || {} : {};
    var overrides = "style" in element ? element.style : {};
    var style = (0, widgetStyle_1.widgetStyle)({
        blockStyle: blockStyle,
        colorProvider: colorProvider,
        overrides: overrides,
        styleableProperties: styleableConfig === null || styleableConfig === void 0 ? void 0 : styleableConfig.properties,
        paragraphColor: (_b = blockStore.blockStyleStore.getElementStyle("p")) === null || _b === void 0 ? void 0 : _b["color"],
    });
    var onChangeHandler = function (path, val) {
        var _a;
        if (usingFeature(FeatureFlag_1.default.WidgetStyleOverrides)) {
            widgetManager.updateStyle(element, (_a = {}, _a[path] = val, _a));
        }
        else {
            var updatedWidgetStyle = (0, lodash_1.cloneDeep)(blockStore.blockStyleStore.getElementStyle(styleableConfig.styleKey));
            (0, lodash_1.set)(updatedWidgetStyle, path, val);
            blockStore.blockStyleStore.setStyleAttribute(styleableConfig.styleKey, updatedWidgetStyle);
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 9 }, function () {
        var _a, _b;
        return (react_1.default.createElement(kaleidoscope_1.Toolbar, { element: anchorElement, visible: widgetSelectionState === "circle" && !dragStore.isDragging, positionType: kaleidoscope_1.ToolbarPositionType.Element, autoStack: true },
            WidgetButtons ? react_1.default.createElement(WidgetButtons, { element: element }) : null,
            isAlignable ? (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.AlignLeft, null), "aria-label": "left align", selected: element.data.alignment === "left", onClick: function () {
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                        action: "update",
                        path: widgetManager.getPath(element),
                        data: {
                            alignment: "left",
                        },
                    }));
                }, disabled: disableLeftAlignment, tooltip: disableLeftAlignment
                    ? { content: "Wide widgets can't be left aligned", size: kaleidoscope_1.TooltipSize.Large }
                    : undefined })) : null,
            isAlignable ? (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.AlignCenter, null), "aria-label": "center align", selected: element.data.alignment === "center", onClick: function () {
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                        action: "update",
                        path: widgetManager.getPath(element),
                        data: {
                            alignment: "center",
                        },
                    }));
                } })) : null,
            styleableConfig &&
                !styleableConfig.hideInToolbar &&
                hasStyleAccess(styleableConfig.styleAccessKey, stylePermissionStore) &&
                !((_a = styleableConfig.hideInToolbarInBlocks) === null || _a === void 0 ? void 0 : _a.includes(blockStore.blockType)) ? (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Styles, null) })); }, autoStack: true },
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" },
                    react_1.default.createElement(kaleidoscope_1.Text, { theme: "dark", size: "m", strong: true }, (_b = config === null || config === void 0 ? void 0 : config.displayName) !== null && _b !== void 0 ? _b : (0, StringManipulater_1.titleCase)(element.type),
                        " styles"),
                    styleableConfig.properties.map(function (property) {
                        var _a;
                        if (property.type === "color" && (!property.showIf || property.showIf(style, element))) {
                            var colorStyle_1 = (0, lodash_1.get)(style, property.path);
                            var color = (0, GetBlockStyle_1.convertColorObjToColor)(colorStyle_1);
                            return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s", className: styles.colorPalette({ hugPreviousControl: property.hugPreviousControl }) },
                                react_1.default.createElement(kaleidoscope_1.Label, { theme: "dark", size: "s", hidden: property.labelHidden }, property.label),
                                react_1.default.createElement(ColorPalette_1.default, { key: property.path, onColorChange: function (color) {
                                        var _a;
                                        var colorObj = __assign(__assign({}, colorStyle_1), (0, GetBlockStyle_1.convertColorToColorObj)(color));
                                        if (property.opacity) {
                                            colorObj.abs = (0, Styleable_1.applyOpacityToColor)(colorObj, (_a = colorObj.opacity) !== null && _a !== void 0 ? _a : property.opacity.defaultValue);
                                        }
                                        onChangeHandler(property.path, colorObj);
                                    }, presetColors: (0, Styleable_1.getPresetColorsForProperty)(property, colorProvider), selectedColor: property.opacity ? __assign(__assign({}, color), { value: (0, Styleable_1.applyOpacityToColor)(color, 1) }) : color, type: "content" }),
                                property.opacity && (react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: function (value) {
                                        var nextColor = (0, lodash_1.cloneDeep)(colorStyle_1);
                                        var nextOpacity = value / 100;
                                        nextColor.opacity = nextOpacity;
                                        nextColor.abs = (0, Styleable_1.applyOpacityToColor)(colorStyle_1, nextOpacity);
                                        onChangeHandler(property.path, nextColor);
                                    }, theme: kaleidoscope_1.SliderTheme.Dark, label: property.opacity.label, unit: "%", initialInputValue: Math.floor(((_a = (0, lodash_1.get)(style, property.path).opacity) !== null && _a !== void 0 ? _a : property.opacity.defaultValue) * 100), minimum: 0, maximum: 100 }))));
                        }
                        if (property.type === "numerical" &&
                            (!property.showIf || property.showIf(style, element))) {
                            return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
                                react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: function (value) { return onChangeHandler(property.path, value); }, theme: kaleidoscope_1.SliderTheme.Dark, label: property.label, unit: property.suffix, initialInputValue: (0, lodash_1.get)(style, property.path), maximum: property.max, minimum: property.min })));
                        }
                        if (property.type === "enumerable" && (!property.showIf || property.showIf(style, element))) {
                            return (react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: property.label, size: kaleidoscope_1.SegmentedControlSize.Medium, options: property.options.map(function (_a) {
                                    var Icon = _a.icon, option = __rest(_a, ["icon"]);
                                    return (__assign(__assign({}, option), (!!Icon ? { icon: react_1.default.createElement(Icon, null) } : {})));
                                }), selectedValue: (0, lodash_1.get)(style, property.path), onClickHandler: function (tokenValue) { return onChangeHandler(property.path, tokenValue); } }));
                        }
                        if (property.type === "alignable") {
                        }
                        if (property.type === "fontSize") {
                        }
                        if (property.type === "boolean") {
                            return (react_1.default.createElement(kaleidoscope_1.Toggle, { label: property.label, value: (0, lodash_1.get)(style, property.path, property.defaultValue), onChange: function (nextValue) { return onChangeHandler(property.path, nextValue); }, theme: "dark" }));
                        }
                        return react_1.default.createElement(react_1.default.Fragment, null);
                    })))) : null,
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Delete, null), tooltip: { content: "delete" }, onClick: function () {
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                        action: "delete",
                        path: widgetManager.getPath(element),
                        type: element.type,
                    }));
                    clearSelection();
                }, isDestructive: true }),
            usingFeature(FeatureFlag_1.default.WidgetStyleOverrides) ? (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.ThumbsUp, null), "aria-label": "propogate styles to block", disabled: Object.keys(style).every(function (key) { return JSON.stringify(blockStyle[key]) === JSON.stringify(style[key]); }), tooltip: { content: "Apply widget styles to block" }, onClick: function () {
                    blockStore.blockStyleStore.setStyleAttribute(styleableConfig.styleKey, __assign(__assign({}, blockStyle), style));
                    widgetManager.clearStyle(element);
                } })) : null));
    }));
});
var hasStyleAccess = function (styleAccessKey, stylePermissionStore) {
    if (!styleAccessKey) {
        return true;
    }
    return stylePermissionStore.allowStyle(styleAccessKey);
};
